import { Injectable } from '@angular/core';

interface RejectableDeferred<T = unknown> {
  promise: Promise<T>;
  reject: (reason?: unknown) => void;
}

@Injectable({
  providedIn: 'root',
})
export class RejectOnTimeoutService {
  static readonly LOAD_TIMEOUT = 60 * 1000;

  rejectOnTimeout(deferred: RejectableDeferred, entry: string) {
    const rejectTimeout = window.setTimeout(() => {
      deferred.reject({
        code: -1,
        message: `${entry} Load Timeout`,
      });
    }, RejectOnTimeoutService.LOAD_TIMEOUT);

    deferred.promise
      .finally(() => {
        window.clearTimeout(rejectTimeout);
      })
      .catch(() => {});
  }

  withTimeout<T>(promise: Promise<T>, entry: string): Promise<T> {
    let rejectTimeout: number;
    const timeoutPromise = new Promise<T>((_resolve, reject) => {
      rejectTimeout = window.setTimeout(() => {
        reject({
          code: -1,
          message: `${entry} Load Timeout`,
        });
      }, RejectOnTimeoutService.LOAD_TIMEOUT);
    });

    return Promise.race([promise, timeoutPromise]).finally(() => {
      window.clearTimeout(rejectTimeout);
    });
  }
}
